































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Order } from '@/store/OrderModel';
import { OrderModule } from '@/store/OrderModule';
import { Product } from '@/store/ProductModel';

@Component
export default class ProductItem extends Vue {
  @Prop({ default: null })
  public readonly product!: Product;

  public productData: Product = this.product;

  public addToOrder() {
    OrderModule.addProductToOrder({ product: this.productData, quantity: 1 });
  }
}
